import React, { PureComponent } from 'react';
import {
  Nav,
  NavItem,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  Col,
  Container,
  Row
} from 'reactstrap';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { Link } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap';
import URI from 'urijs';
import { omit } from 'underscore';
import cx from 'classnames';

// modules
import BS from '../../theme/Bootstrap';
import styles from '../Containers.module.scss';
import cmpStyle from '../../components/Components.module.scss';

// ducks
import { fetch } from '../../ducks/OfficeSearch';

// components
import LoadError from '../../components/load-error/load-error';
import BrokerageCard from '../../partials/brokerage-card/brokerage-card';

// containers
import AgentSearch from '../AgentSearch/AgentSearch';
import PropertySearch from '../PropertySearch/PropertySearch';

class OfficeDetail extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      activeImage: undefined,
      showMap: false
    };
  }

  render() {
    const { error, id, record, currentURI, searchURI, detailURI, isLoading, loaded } =
      this.props;
    const isLoaded = !isLoading && loaded === id;
    const officeType = record.get('officeType');
    var agentsTitle = 'Agents';
    var memberType = 'realtor';

    if (officeType === 'service_company') {
      agentsTitle = 'Providers';
      memberType = 'service_provider';
    }

    return (
      <Container className={cx(cmpStyle.detail, styles.OfficeDetail)}>
        <Row>
          <Breadcrumb>
            <LinkContainer exact to="/">
              <BreadcrumbItem>
                <Link to="/">Home</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to="/find-naples-firm">
              <BreadcrumbItem>
                <Link to="/find-naples-firm">Firm Search</Link>
              </BreadcrumbItem>
            </LinkContainer>
            <LinkContainer exact to={`/firm/${encodeURIComponent(id)}`}>
              <BreadcrumbItem>
                <Link to={`/firm/${encodeURIComponent(id)}`}>
                  {id ? id.replace(/(-)/g, ' ') : id}
                </Link>
              </BreadcrumbItem>
            </LinkContainer>
            <Switch>
              <Route
                path="/firm/:id/listings"
                exact
                render={() => <BreadcrumbItem>Listings</BreadcrumbItem>}
              />
              <Route
                path="/firm/:id/listings/advanced"
                exact
                render={() => <BreadcrumbItem>Listings Advanced</BreadcrumbItem>}
              />
            </Switch>
          </Breadcrumb>
        </Row>
        <Route
          path="/firm/:id"
          render={() => (
            <Container className={`${BS.breadcrumb2}`}>
              <Row>
                <Nav horizontal="space-between" className={`${BS.mt0} ${BS.mb3}`}>
                  {searchURI && !detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={searchURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                  {detailURI && (
                    <NavItem>
                      <Button color="link" tag={Link} to={detailURI}>
                        &lt; Back
                      </Button>
                    </NavItem>
                  )}
                </Nav>
              </Row>
            </Container>
          )}
        />
        {isLoading && <div className={BS.loadingMask}>Loading</div>}
        {error && <LoadError error={error} retry={() => this.reload()} />}
        {isLoaded && (
          <div className={cmpStyle.header}>
            <h4>{record.get('company')}</h4>
          </div>
        )}
        {isLoaded && (
          <Row>
            <Col xs={12} md={5} className={`${BS.mb3} ${BS.dFlex}`}>
              <BrokerageCard
                tag="div"
                data={record.toJS()}
                className={`${BS.border0} ${BS.p0}`}
                detailURI={currentURI}
              />
            </Col>
            <Col xs={12} md={7} className={`${BS.mb3} ${BS.dFlex} ${BS.pt3}`}>
              <div className={`${BS.pl3} ${BS.pr3} ${styles.agentDescription}`}>
                About the Office:
                <p
                  dangerouslySetInnerHTML={{
                    __html:
                      record.getIn(['extended', 'content']) ||
                      "We are currently in the process of updating our firm's profile. Should you like to contact us, please use our contact information at the left and we will be happy to assist you with your real estate needs."
                  }}
                />
              </div>
            </Col>
          </Row>
        )}
        {isLoaded && officeType === 'service_company' && (
          <React.Fragment>
            <hr />
            <h5 className={BS.p1}>{`${agentsTitle} for ${record.get('company')}`}</h5>
            <Row className={cx(cmpStyle.details, BS.flex1)}>
              <AgentSearch
                firmId={record.get('id')}
                firm={record.get('company')}
                hideBreadcrumb
                memberType={memberType}
                pathname={`/firm/${encodeURIComponent(id)}`}
                pathnameAdvanced={`/firm/${encodeURIComponent(id)}/advanced`}
                pathnameAdvancedResults={`/firm/${encodeURIComponent(
                  id
                )}/advanced/results`}
              />
            </Row>
          </React.Fragment>
        )}
        {isLoaded && officeType !== 'service_company' && (
          <Route
            path="/firm/:id/agents"
            render={() => (
              <React.Fragment>
                <hr />
                <h5 className={BS.p1}>{`${agentsTitle} for ${record.get('company')}`}</h5>
                <Row className={cx(cmpStyle.details, BS.flex1)}>
                  <AgentSearch
                    firmId={record.get('id')}
                    firm={record.get('company')}
                    hideBreadcrumb
                    memberType={memberType}
                    pathname={`/firm/${encodeURIComponent(id)}/agents`}
                    pathnameAdvanced={`/firm/${encodeURIComponent(id)}/agents/advanced`}
                    pathnameAdvancedResults={`/firm/${encodeURIComponent(
                      id
                    )}/agents/advanced/results`}
                  />
                </Row>
              </React.Fragment>
            )}
          />
        )}
        {isLoaded && officeType === 'brokerage' && (
          <Route path="/firm/:id/(listings|recently_sold)">
            {({ match, ...rest }) => {
              if (!match) {
                return null;
              }

              const isInListings = match.url.indexOf('/listings') !== -1;
              const title = isInListings ? 'Listings' : 'Recently Sold';
              const pathPart = isInListings ? 'listings' : 'recently_sold';

              return (
                <React.Fragment>
                  <hr />
                  <h5 className={BS.p1}>{`${title} for ${record.get('company')}`}</h5>
                  <Row className={cx(cmpStyle.details, BS.flex1)}>
                    <PropertySearch
                      firmId={record.get('id')}
                      hideBreadcrumb
                      recentlySold={isInListings ? '' : '1'}
                      pathname={`/firm/${encodeURIComponent(id)}/${pathPart}`}
                      pathnameAdvanced={`/firm/${encodeURIComponent(
                        id
                      )}/${pathPart}/advanced`}
                      pathnameAdvancedResults={`/firm/${encodeURIComponent(
                        id
                      )}/${pathPart}/advanced/results`}
                    />
                  </Row>
                </React.Fragment>
              );
            }}
          </Route>
        )}
      </Container>
    );
  }

  componentWillMount() {
    this.checkAndLoad();
  }

  componentDidUpdate() {
    this.checkAndLoad();
  }

  checkAndLoad() {
    const { loaded, isLoading, error, load, id } = this.props;
    if ((!loaded || loaded !== id) && !isLoading && (!error || loaded !== id)) {
      load({ id });
    }
  }

  reload() {
    const { load, id } = this.props;

    if (load && id) {
      load({ id });
    }
  }
}

export default connect(
  (state, props) => {
    const id = props.match.params.id;
    const { searchURI, detailURI } = URI(state.routing.location.search).search(true);
    const { pathname, search = {} } = state.routing.location;

    return {
      id: id !== undefined ? decodeURIComponent(id) : id,
      record: state.OfficeSearch.getIn(['detail', 'record']),
      isLoading: state.OfficeSearch.getIn(['detail', 'loading']),
      loaded: state.OfficeSearch.getIn(['detail', 'loaded']),
      error: state.OfficeSearch.getIn(['detail', 'error']),
      // These additional URIjs methods are being called to santitize the URL
      searchURI: searchURI
        ? URI(searchURI).protocol('').hostname('').port('').normalizePathname().toString()
        : '/find-naples-firm',
      detailURI:
        detailURI &&
        URI(detailURI).protocol('').hostname('').port('').normalizePathname().toString(),
      currentURI:
        pathname &&
        URI(pathname).search(omit(search, 'detailURI', 'searchURI')).toString()
    };
  },
  { load: fetch }
)(OfficeDetail);



// WEBPACK FOOTER //
// ./src/containers/OfficeDetail/OfficeDetail.js